
<div id="dfx-apply">
  <router-view />
</div>
